import { createAction } from 'redux-actions';
import { displayError, displaySuccess } from './notificacoesActions';
import usuariosApi from '../../utils/api/usuariosApi';

export const createUsuarioRequest = createAction('CREATE_USUARIO_REQUEST');
export const createUsuarioSuccess = createAction('CREATE_USUARIO_SUCCESS');

export const getUsuarioRequest = createAction('GET_USUARIO_REQUEST');
export const getUsuarioSuccess = createAction('GET_USUARIO_SUCCESS');

export const updateUsuarioRequest = createAction('UPDATE_USUARIO_REQUEST');
export const updateUsuarioSuccess = createAction('UPDATE_USUARIO_SUCCESS');

export const deleteUsuarioRequest = createAction('DELETE_USUARIO_REQUEST');
export const deleteUsuarioSuccess = createAction('DELETE_USUARIO_SUCCESS');

export const fetchUsuariosRequest = createAction('FETCH_USUARIOS_REQUEST');
export const fetchUsuariosSuccess = createAction('FETCH_USUARIOS_SUCCESS');

export const fetchSearchUsuariosRequest = createAction(
  'FETCH_SEARCH_USUARIOS_REQUEST'
);
export const fetchSearchUsuariosSuccess = createAction(
  'FETCH_SEARCH_USUARIOS_SUCCESS'
);

export const newUsuarioRequest = createAction('NEW_USUARIO_REQUEST');

export const getStatsUsuariosRequest = createAction(
  'GET_STATS_USUARIOS_REQUEST'
);
export const getStatsUsuariosSuccess = createAction(
  'GET_STATS_USUARIOS_SUCCESS'
);
export const getStatsUsuariosError = createAction('GET_STATS_USUARIOS_ERROR');

export const fetchUsuarios = (page, pageSize) => async (dispatch) => {
  try {
    dispatch(fetchUsuariosRequest());
    const { data } = await usuariosApi.listUsuarios(page, pageSize);
    dispatch(fetchUsuariosSuccess(data));
  } catch (e) {
    console.log(e);
    dispatch(displayError(e));
  }
};

export const getUsuario = (id) => async (dispatch) => {
  try {
    dispatch(getUsuarioRequest());
    const { data } = await usuariosApi.readUsuario(id);
    dispatch(getUsuarioSuccess(data));
  } catch (e) {
    console.log(e);
    dispatch(displayError(e));
  }
};

export const createUsuario = (form) => async (dispatch) => {
  try {
    dispatch(createUsuarioRequest());
    const { data } = await usuariosApi.createUsuario(form);

    dispatch(displaySuccess('Usuario incluído com sucesso!'));
    dispatch(createUsuarioSuccess(data));
  } catch (e) {
    console.log(e);
    dispatch(displayError(e));
  }
};

export const updateUsuario = (id, form) => async (dispatch) => {
  try {
    dispatch(updateUsuarioRequest());
    const { data } = await usuariosApi.updateUsuario(id, form);
    dispatch(displaySuccess('Usuario atualizado com sucesso!'));
    dispatch(updateUsuarioSuccess(data));
  } catch (e) {
    console.log(e);
    dispatch(displayError(e));
  }
};

export const deleteUsuario = (id) => async (dispatch) => {
  try {
    dispatch(deleteUsuarioRequest());
    const { data } = await usuariosApi.deleteUsuario(id);
    dispatch(deleteUsuarioSuccess(data.message));
  } catch (e) {
    console.log(e);
    dispatch(displayError(e));
  }
};

export const newUsuario = () => async (dispatch) => {
  dispatch(newUsuarioRequest());
};

export const fetchSearchUsuarios =
  (page, pageSize, search) => async (dispatch) => {
    try {
      dispatch(fetchSearchUsuariosRequest());
      const { data } = await usuariosApi.searchUsuarios(page, pageSize, search);
      dispatch(fetchSearchUsuariosSuccess(data));
    } catch (e) {
      console.log(e);
      dispatch(displayError(e));
    }
  };

export const getStatsUsuarios = () => async (dispatch) => {
  try {
    dispatch(getStatsUsuariosRequest());
    const { data } = await usuariosApi.getStatsUsuarios();
    dispatch(getStatsUsuariosSuccess(data));
  } catch (e) {
    console.log(e);
    dispatch(getStatsUsuariosError(e));
    dispatch(displayError(e));
  }
};
